import { db, auth } from "@/firebase/config";
import { doc, setDoc, serverTimestamp, collection, query, where, getDocs } from "firebase/firestore";

const addPlayerLocation = async (pId, lId, setHome = false, bypassLimit = false) => {

    // new bandaid as of 12/27/24 to always set home in case they clicked add favorite during setup, shouldn't hurt anything bc home concept is being deprecated
    setHome = true // disabled bandaid
    // REGISTRATION STILL RELIES HEAVILE ON HOMELOC BEING SET DURING REG SO: we will need a special flag for registration = true to turn this on, or, a cloud function or something
    
    if (pId && lId) {
        const currentUser = auth.currentUser;
        if (!currentUser?.uid) {
            throw new Error("User must be logged in to update player location.");
        }
        // new query playerLocations first to see if this player has >= 10 locations already and if so, alert and return

        try {
            // Query the playerLocations collection for records matching the playerId
            const playerLocationsRef = collection(db, "playerLocations");
            const playerQuery = query(playerLocationsRef, where("playerId", "==", pId), where("removed", "==", false));
            const querySnapshot = await getDocs(playerQuery);

            // Check if the player has 15 or more favorite locations
            let maxLocLimit = bypassLimit ? 99 : 10
            const hasReachedLimit = querySnapshot.size >= maxLocLimit;
            if (hasReachedLimit) {
                alert(`There is a limit of ${maxLocLimit} active venues per player.`)
                return
            } else {
                try {
                    await setDoc(doc(db, "playerLocations", pId + lId), {
                        created: serverTimestamp(),
                        locationId: lId,
                        playerId: pId,
                        userId: currentUser.uid,
                        removed: false
                    })
                } catch (error) {
                    throw error;  // rethrowing the error so the calling function is aware an error occurred
                }
            }
        } catch (error) {
            console.error(`Error adding player location for Player ID: ${pId}, Location ID: ${lId}`, error);
            console.log("Error in adding location")
            throw error;  // rethrowing the error so the calling function is aware an error occurred
        }


        if (setHome) {
            // console.log('updating home location')
            try {
                await setDoc(
                    doc(db, "players", pId),
                    {
                        homeLocation: lId,
                        userId: currentUser.uid,
                    },
                    { merge: true }
                );
            } catch (error) {
                console.error(`Error setting home location for Player ID: ${pId}, Location ID: ${lId} in players collection`, error);
                throw error;  // rethrowing the error so the calling function is aware an error occurred
            }
        }
    }
}

const remPlayerLocation = async (pId, lId) => {
    // you need to choose another home location
    if (pId && lId) {
        try {
            await setDoc(doc(db, "playerLocations", pId + lId), {
                removed: serverTimestamp(),
                locationId: lId,
                playerId: pId,
                userId: auth.currentUser.uid,
                removed: true,
            });
        } catch (error) {
            console.error(`Error adding player location for Player ID: ${pId}, Location ID: ${lId}`, error);
            console.log("Error in adding location")
            throw error;  // rethrowing the error so the calling function is aware an error occurred
        }

    }

}

export default addPlayerLocation;
// for backward compatibility
export { remPlayerLocation };